module.exports = __webpack_public_path__ + "img/banner_kpis.dbc0f59d.png";